import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageLoadingBar() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setVisible(true);
    setProgress(0);

    const raf1 = requestAnimationFrame(() => {
      setProgress(40);
    });

    const raf2 = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setProgress(70);
      });
    });

    const finish = setTimeout(() => {
      setProgress(100);
      const hide = setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 300);
      return () => clearTimeout(hide);
    }, 200);

    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
      clearTimeout(finish);
    };
  }, [pathname]);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 w-full z-[100] h-[3px] bg-transparent">
      <div
        className="h-full bg-[#7B1113] transition-all ease-out"
        style={{
          width: `${progress}%`,
          transitionDuration: progress === 100 ? '300ms' : '500ms',
        }}
      />
    </div>
  );
}